import { useContext, useEffect, useState } from "react";
import { Product_2 } from "../../types/types_product_2";
import { Product } from "../../types/types_product";
import { ProductsDataContext } from "../../pages/Home/Home";
import { fetchData } from "../../shared/api/api";
import { addImagesToProducts, sortProductsData } from "../../utils/utils";
import { products } from "../../data/products";

function FetchProductsData() {
   const [products_2] = useState<Product_2[]>(products);

   const context = useContext(ProductsDataContext);
   if (!context) {
      throw new Error(
         "PromoDataContext is not provided. Please wrap your component with PromoDataContext.Provider."
      );
   }
   const { setProductsData } = context;

   useEffect(() => {
      const fetchProducts = async () => {
         // const API_URL =
         //    process.env.NODE_ENV === "production"
         //       ? process.env.REACT_APP_SERVER_API
         //       : process.env.REACT_APP_API_URL;
         const API_URL = process.env.REACT_APP_SERVER_API

         const isProduct_2 = (
            item: Product | Product_2 | undefined
         ): item is Product_2 => {
            return !!item && "newItem" in item;
         };

         const cached = localStorage.getItem("products_cache");

         if (cached) {
            try {
               const parsed = JSON.parse(cached);
               setProductsData(sortProductsData(parsed, isProduct_2));
            } catch { }
         }

         let serverResponded = false;
         fetchData<Product[]>(`${API_URL}/api/products`)
            .then((response) => {
               serverResponded = true;
               if (Array.isArray(response)) {
                  const prepared =
                     response.length > 0
                        ? response.flat().filter(Boolean)
                        : addImagesToProducts(products_2);

                  const sorted = sortProductsData(prepared, isProduct_2);
                  setProductsData(sorted);
                  localStorage.setItem("products_cache", JSON.stringify(sorted));
               }
            })
            .catch((err) => {
               console.error("ERROR: product download:", err.message);
            });

         await new Promise((resolve) => setTimeout(resolve, 900));

         if (!serverResponded) {
            // console.warn("Server did not respond within 900 ms — keeping cache.");
         }
      };

      fetchProducts();
   }, [products_2, setProductsData]);

   return null;
}


export default FetchProductsData